export function customScrollbar() {
	$('.custom-scroll-holder').mCustomScrollbar({
		theme: "cstscroll"
	});
}





// WEBPACK FOOTER //
// ./assets/js/modules/customScrollbar.js